<template>
  <notice-message variant="info">
    You don't need to ask if things are still available. People can mark OFFERs
    as promised or TAKEN, and you'd see that here. So just write whatever you
    would have said next - explain why you'd like it and when you could collect.
  </notice-message>
</template>
<script>
import NoticeMessage from '~/components/NoticeMessage'

export default {
  components: { NoticeMessage },
}
</script>
